module.exports = __webpack_public_path__ + "static/media/Banner_ebooks.7f64f0ec.png";